import { render } from "./OptionSets.vue?vue&type=template&id=32975a14"
import script from "./OptionSets.vue?vue&type=script&lang=js"
export * from "./OptionSets.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__